import type { BlockComponentsProps } from '@winnin/winnin_ui.components.block-components'
import { BlockComponents } from '@winnin/winnin_ui.components.block-components'

import { useTranslate } from 'lib/tolgee'
import { UserStore } from 'stores'
import { TOLGEE_GLOBALS } from 'utils'

type BlockComponentsRole75CheckerProps = BlockComponentsProps

function BlockComponentsRole75Checker({
  children,
  tooltipPositionClassname,
  ...props
}: BlockComponentsRole75CheckerProps) {
  const t = useTranslate()

  if (UserStore.userInfo.role === 75) {
    return (
      <BlockComponents
        isClickBlocked={true}
        blockMessage={t(TOLGEE_GLOBALS.worldCupWorkspace)}
        tooltipPositionClassname={tooltipPositionClassname}
      >
        {children}
      </BlockComponents>
    )
  }
  return (
    <BlockComponents tooltipPositionClassname={tooltipPositionClassname} {...props}>
      {children}
    </BlockComponents>
  )
}

export default BlockComponentsRole75Checker
